import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetContentCountSlice = createSlice({
    name: "getContentCount",
    initialState,
    reducers: {
        getContentCountRequest(state) {
            state.loading = true;
        },
        getContentCountRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getContentCountRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getContentCountRequest,
    getContentCountRequestSuccess,
    getContentCountRequestError,
} = GetContentCountSlice.actions;

export default GetContentCountSlice.reducer;
